/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import RefundTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import { form, AppendixForm } from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import SelectField from "components/SelectField";
import SoftTypography from "components/SoftTypography";
import Footer from "./components/footer";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaidAmountTable from "./components/paid-amount-table";
import AppendixTable from "./components/appendixTable";
const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};
export default function DNHUY() {
  const { formId, formField } = form;
  const { formIdAppendix, formFieldAppendix } = AppendixForm;
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([{ name: "02-1/HT", checked: false }]);
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        <Box display="flex" flexDirection="column" pb={10} gap={3}>
          <Box textAlign="center">
            <Typography variant="h4" textTransform="uppercase">
              Văn bản đề nghị hủy hồ sơ đề nghị hoàn thuế - mẫu 01/ĐNHUY
            </Typography>
          </Box>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form id={formId} autoComplete="off">
                <Fields
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />

                <Footer
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />
                <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                  <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                    {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                  </SoftButton>
                </SoftBox>
              </Form>
            )}
          </Formik>
        </Box>
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    id,
    date,
    sendTo,
    payerName,
    taxID,
    address,
    agency,
    taxRefundDocument,
    taxRefundDate,
    tradeID,
    notificationReceivingAgency,
    receivedDate,
    why,
    chiefAccountant,
    certificateNumber,
    signer,
  } = formField;
  const [checked, setChecked] = React.useState([true, false]);
  const handleChange1 = (event) => {
    setChecked([event.target.checked, event.target.checked]);
  };

  const handleChange2 = (event) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event) => {
    setChecked([checked[0], event.target.checked]);
  };
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={id.name}
            label={id.label}
            value={values.id}
            error={errors.id && touched.id}
            success={values.id?.toString().length > 0 && !errors.id}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={date.name}
            label={date.label}
            value={values.date}
            error={errors.date && touched.date}
            success={values.date?.toString().length > 0 && !errors.date}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={sendTo.name}
            label={sendTo.label}
            value={values.sendTo}
            error={errors.sendTo && touched.sendTo}
            success={values.sendTo?.toString().length > 0 && !errors.sendTo}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            I. THÔNG TIN CHUNG:
          </SoftTypography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={payerName.name}
            label={payerName.label}
            value={values.payerName}
            error={errors.payerName && touched.payerName}
            success={values.payerName?.toString().length > 0 && !errors.payerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxID.name}
            label={taxID.label}
            value={values.taxID}
            error={errors.taxID && touched.taxID}
            success={values.taxID?.toString().length > 0 && !errors.taxID}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={agency.name}
            label={agency.label}
            value={values.agency}
            error={errors.agency && touched.agency}
            success={values.agency?.toString().length > 0 && !errors.agency}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            II. THÔNG TIN CHI TIẾT:
          </SoftTypography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            1. Tên hồ sơ đề nghị hủy:
          </SoftTypography>
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
            <div>
              <FormControlLabel
                label="văn bản đề nghị xử lý số tiền thuế, tiền chậm nộp,tiền phạt nộp thừa mẫu số 01/ĐNXLNT"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
              <FormControlLabel
                label="Giấy đề nghị hoàn trả khoản thu ngân sách nhà nước mẫu số 01/HT"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
              <FormControlLabel
                label="Giấy đề nghị hoàn trả khoản thu ngân sách nhà nước mẫu số 01a/ĐNHT"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
              <FormControlLabel
                label="Giấy đề nghị hoàn trả khoản thu ngân sách nhà nước mẫu số 02/HT"
                control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
              />
            </div>
          </Box>
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            2. Thông tin hồ sơ đề nghị hủy:
          </SoftTypography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={payerName.name}
            label={payerName.label}
            value={values.payerName}
            error={errors.payerName && touched.payerName}
            success={values.payerName?.toString().length > 0 && !errors.payerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxID.name}
            label={taxID.label}
            value={values.taxID}
            error={errors.taxID && touched.taxID}
            success={values.taxID?.toString().length > 0 && !errors.taxID}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxRefundDocument.name}
            label={taxRefundDocument.label}
            value={values.taxRefundDocument}
            error={errors.taxRefundDocument && touched.taxRefundDocument}
            success={values.taxRefundDocument?.toString().length > 0 && !errors.taxRefundDocument}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxRefundDate.name}
            label={taxRefundDate.label}
            value={values.taxRefundDate}
            error={errors.taxRefundDate && touched.taxRefundDate}
            success={values.taxRefundDate?.toString().length > 0 && !errors.taxRefundDate}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={tradeID.name}
            label={tradeID.label}
            value={values.tradeID}
            error={errors.tradeID && touched.tradeID}
            success={values.tradeID?.toString().length > 0 && !errors.tradeID}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={notificationReceivingAgency.name}
            label={notificationReceivingAgency.label}
            value={values.notificationReceivingAgency}
            error={errors.notificationReceivingAgency && touched.notificationReceivingAgency}
            success={
              values.notificationReceivingAgency?.toString().length > 0 &&
              !errors.notificationReceivingAgency
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={receivedDate.name}
            label={receivedDate.label}
            value={values.receivedDate}
            error={errors.receivedDate && touched.receivedDate}
            success={values.receivedDate?.toString().length > 0 && !errors.receivedDate}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={why.name}
            label={why.label}
            value={values.why}
            error={errors.why && touched.why}
            success={values.why?.toString().length > 0 && !errors.why}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
function MoreFields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { accountOwner, bankAccountNumber, bankName, attachDocument } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 30 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography component="label" variant="caption" fontWeight="normal" mb={0.5}>
              2. Thông tin người nộp thuế đề nghị hoàn trả khoản thu ngân sách nhà nước
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={accountOwner.name}
            label={accountOwner.label}
            value={values.accountOwner}
            error={errors.accountOwner && touched.accountOwner}
            success={values.accountOwner?.toString().length > 0 && !errors.accountOwner}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={bankAccountNumber.name}
            label={bankAccountNumber.label}
            value={values.bankAccountNumber}
            error={errors.bankAccountNumber && touched.bankAccountNumber}
            success={values.bankAccountNumber?.toString().length > 0 && !errors.bankAccountNumber}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={bankName.name}
            label={bankName.label}
            value={values.bankName}
            error={errors.bankName && touched.bankName}
            success={values.bankName?.toString().length > 0 && !errors.bankName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={attachDocument.name}
            label={attachDocument.label}
            value={values.attachDocument}
            error={errors.attachDocument && touched.attachDocument}
            success={values.attachDocument?.toString().length > 0 && !errors.attachDocument}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
